<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"

const buildingImageUrl = new URL("../../../assets/images/biulding.svg", import.meta.url).href
</script>

<template>
  <AppShell>
    <div class="mx-auto max-w-3xl space-y-6">
      <section class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <h1 class="text-2xl font-semibold text-slate-900">Custos indiretos</h1>
        <p class="mt-2 text-sm text-slate-600">Definicoes de custos adicionais e rateios para analise de margem.</p>
      </section>

      <section class="rounded-lg border border-slate-200 bg-white p-10 text-center shadow-sm">
        <img :src="buildingImageUrl" alt="Modulo em breve" class="mx-auto h-36 w-36" />
        <h2 class="mt-4 text-xl font-semibold text-slate-900">Em breve</h2>
        <p class="mt-2 text-sm text-slate-600">Estamos preparando este modulo para permitir configuracoes detalhadas de custos indiretos.</p>
      </section>
    </div>
  </AppShell>
</template>


